// @flow
import { EventosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    evento: {},
    listaEventos: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type EventosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { evento?: {} | null, listaEventos?: [] | null, loading?: boolean, +value ?: boolean };

const Eventos = (state: State = INIT_STATE, action: EventosAction): any => {
    // console.log(action);
    switch (action.type) {
        case EventosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EventosActionTypes.GET_EVENTO: {
                    return {
                        ...state,
                        evento: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EventosActionTypes.LIST_EVENTOS: {
                    return {
                        ...state,
                        listaEventos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case EventosActionTypes.ADD_EVENTO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventosActionTypes.UPDATE_EVENTO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventosActionTypes.DELETE_EVENTO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EventosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EventosActionTypes.GET_EVENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        evento: {},
                        loading: false,
                    };
                }
                case EventosActionTypes.LIST_EVENTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaEventos: [],
                        loading: false,
                    };
                }
                case EventosActionTypes.ADD_EVENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventosActionTypes.UPDATE_EVENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case EventosActionTypes.DELETE_EVENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case EventosActionTypes.GET_EVENTO:
            return { ...state, error: false, loading: true };
        case EventosActionTypes.LIST_EVENTOS:
            return { ...state, error: false, loading: true };
        case EventosActionTypes.ADD_EVENTO:
            return { ...state, error: false, loading: true };
        case EventosActionTypes.UPDATE_EVENTO:
            return { ...state, error: false, loading: true };
        case EventosActionTypes.DELETE_EVENTO:
            return { ...state, error: false, loading: true };
        case EventosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                evento: {},
                listaEventos: [],
                formSubmited: false
            };
        case EventosActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Eventos;
